var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosy = function SvgClosy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 7 7m7 7L8 8m0 0-7 7m7-7 7-7",
    stroke: "#000",
    strokeWidth: 1.6
  })));
};
export { SvgClosy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMSAxTDggOE0xNSAxNUw4IDhNOCA4TDEgMTVNOCA4TDE1IDEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS42IiAvPgo8L3N2Zz4=";